import { useState } from "react";
import * as borogove from "borogove";
import {
	Autocomplete,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from "@mui/material";

const newTags = (existing: string[], possibleNew: string) => {
	const trimmed = possibleNew.trim();

	if (!trimmed) {
		return existing;
	}

	return [...existing, trimmed];
};

export const ChannelTagsDialog = ({
	open,
	client,
	initialTags,
	onClose,
	onSave,
}: {
	open: boolean;
	client: borogove.Client;
	initialTags: string[];
	onClose: () => void;
	onSave: (tags: string[]) => void;
}) => {
	const [tags, setTags] = useState(initialTags);
	const [inputValue, setInputValue] = useState("");
	const allKnownTags = [
		...new Set(client.getChats().flatMap((chat) => chat.getTags())),
	];

	const commitInput = () => {
		setTags((existing) => newTags(existing, inputValue));
		setInputValue("");
	};

	const save = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		onSave(newTags(tags, inputValue));
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Chat tags</DialogTitle>
			<form onSubmit={save}>
				<DialogContent>
					<Autocomplete<string, true, false, true>
						multiple
						freeSolo
						options={allKnownTags}
						value={tags}
						inputValue={inputValue}
						onInputChange={(_, value) => setInputValue(value)}
						onChange={(_, value) =>
							setTags(value.map((tag) => tag.trim()).filter(Boolean))
						}
						renderInput={(params) => (
							<TextField
								{...params}
								autoFocus
								label="Tags"
								placeholder="Add a tag"
								helperText="Press Enter to save"
								onBlur={commitInput}
							/>
						)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>Cancel</Button>
					<Button variant="contained" type="submit">
						Save
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
};
